import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SuccessModal extends Component {
  constructor(props) {
    super(props);
    this.removeThisModal = this.removeThisModal.bind(this);
  }

  removeThisModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  render() {
    const { message } = this.props;
    return (
      <div className="card text-white bg-success mb-3" style={{ maxWidth: '18rem', margin: '0 auto' }}>
        <div className="card-body">
          <a className="close clickable" onClick={this.removeThisModal}>x</a>
          <h5 className="card-title">Success</h5>
          <p className="card-text">{ message }</p>
        </div>
      </div>
    );
  }
}

SuccessModal.propTypes = {
  message: PropTypes.string,
  removeModal: PropTypes.func.isRequired,
};

SuccessModal.defaultProps = {
  message: '',
};

export default SuccessModal;
